// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    DEMO STYLE
*/
body {
  font-family: "Poppins", sans-serif;
  background: #fafafa;
}

p {
  font-family: "Poppins", sans-serif;
  font-size: 1.1em;
  font-weight: 300;
  line-height: 1.7em;
  color: #393838;
}
p strong {
  font-weight: 900;
}
.btn {
  background: linear-gradient(45deg, #1b0167, #000);
  color: #fff;
}
ul li a .btn {
  background: linear-gradient(45deg, #1b0167, #000);
  color: #fff;
}
a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.navbar {
  padding: 15px 10px;
  background: #fff;
  border: none;
  border-radius: 0;
  margin-bottom: 40px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

.navbar-btn {
  box-shadow: none;
  outline: none !important;
  border: none;
}

.line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}

/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */

.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
}

#sidebar {
  position: sticky;
  top: 0;
  min-width: 275px !important;
  max-width: 275px !important;
  /* background: #7386d5; */
  background: linear-gradient(45deg, #0d0d42e0, black);
  color: #fff;
  transition: all 0.3s;
  height: 100vh;
  /* overflow-x: scroll; */
  overflow-y: scroll;
}
#sidebar::-webkit-scrollbar {
  width: 10px; /* Adjust the width of the scrollbar */
}

#sidebar::-webkit-scrollbar-thumb {
  background-color: rgb(
    168,
    168,
    168
  ); /* Customize the color of the scrollbar thumb */
  border-radius: 6px; /* Adjust the border-radius to make the scrollbar thumb rounder */
}

#sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #444444; /* Customize the color of the scrollbar thumb on hover */
}

#sidebar::-webkit-scrollbar-track {
  /* background-color: #7386d5 !important; Customize the color of the scrollbar track */
  background: linear-gradient(45deg, #0d0d42e0, black) !important;
}

#sidebar.active {
  margin-left: -275px !important;
}

#sidebar .sidebar-header {
  /* padding: 25px; */
  /* background: #6d7fcc; */
  background: linear-gradient(45deg, #0d0d42e0, black);

  font-weight: bolder;
}
.sidebar-header h3 {
  background: none;
  font-family: cursive;
  font-weight: bolder !important;
  /* color: #7aff79; */
  /* box-shadow: rgba(-9.7, 8.1, -1.2, 0.35) -7px 17px 4px; */
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  padding: 25px;
  font-size: 1.8rem;
}
#sidebar ul.components {
  /* padding: 20px 0; */
  border-bottom: 1px solid #47748b;
}

/* #sidebar ul .dashboard {
    color: #fff;
    padding: 10px;
} */
.dashboard {
  padding: 1rem 0 !important;
  font-weight: bold;
}
/* .dashboard:hover {
  color: #7386D5;
  background: #fff;
} */
#sidebar ul li a {
  padding: 1rem 10px;
  font-size: 17px;
  display: block;
  font-weight: 500;
}
#sidebar ul li .dropdown-toggle::after {
  right: 0px;
}

#sidebar ul li a:hover {
  /* color: #7386d5; */
  /* color: linear-gradient(45deg, #0d0d42e0, black); */
  background: linear-gradient(45deg, #0a0ab4e0, rgb(14, 14, 14));
  /* background: #fff; */
}

#sidebar ul li.active > a,
a[aria-expanded="true"] {
  color: #fff;
  /* background: #6d7fcc;
  */
  background: linear-gradient(45deg, #212197e0, rgba(0, 0, 0, 0.632));
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

ul ul a {
  font-size: 0.9em !important;
  padding-left: 30px !important;
  /* background: #6d7fcc; */
  background: linear-gradient(45deg, #0d0d42e0, black);
}

ul.CTAs {
  padding: 20px;
}

ul.CTAs a {
  text-align: center;
  font-size: 0.9em !important;
  display: block;
  border-radius: 5px;
  margin-bottom: 5px;
}

a.download {
  background: #fff;
  /* color: #7386d5;
   */
  background: linear-gradient(45deg, #0d0d42e0, black);
}

a.article,
a.article:hover {
  /* background: #6d7fcc !important; */
  background: linear-gradient(
    45deg,
    #0f0f52e0,
    rgba(0, 0, 0, 0.873)
  ) !important;

  color: #fff !important;
}

/* ---------------------------------------------------
    CONTENT STYLE
----------------------------------------------------- */
/* .authorCount-container {
  display: flex;
  gap: 10px;
} */

#content {
  width: 100%;
  padding: 20px;
  min-height: 100vh;
  transition: all 0.3s;
}
.chart-box {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.chart-box:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.chart-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}
/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */

@media (max-width: 768px) {
  #sidebar {
    margin-left: -275px;
  }
  #sidebar.active {
    margin-left: 0 !important;
  }
  #sidebarCollapse span {
    display: none;
  }
}
@media (max-width: 400px) {
  .form-group select {
    width: 225px !important;
  }
}

@media (max-width: 450px) {
  .form-group input {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
/* dashboard.css */
#content {
  width: 100%;
  padding: 15px;
  transition: all 0.3s;
  background: #040420;
}

/* Toggle Button */
#sidebarCollapse {
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
}

/* Navbar Styles */
.navbar {
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.navbar .navbar-toggler {
  background-color: #37474f;
  border: none;
  color: white;
  cursor: pointer;
}

/* Miscellaneous */
.line {
  height: 1px;
  background-color: #ccc;
  margin: 20px 0;
}

.list-unstyled {
  padding: 0;
  list-style: none;
}

.list-unstyled a {
  color: white;
  text-decoration: none;
}

.list-unstyled a:hover {
  color: #fff;
}

/* Active link */
.list-unstyled .active > a {
  background-color: #263238;
  color: #fff;
}

/* Dropdown Styles */
.collapse.show {
  display: block;
}

.list-unstyled .dropdown-toggle::after {
  float: right;
  margin-left: auto;
  margin-right: 15px;
}

/* CTAs Styles */
.CTAs {
  padding: 20px;
}

.CTAs a {
  color: #007bff;
  text-decoration: none;
  transition: all 0.3s;
}

.CTAs a:hover {
  color: #0056b3;
  text-decoration: none;
}

/* Additional Styling for Overlay */
#overlay {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
}
.auth-btns button {
  background: white;
  font-weight: 600;
}
.auth-btns li a {
  /* padding: 0; */
  /* background: rgb(46, 46, 248); */
  font-weight: bold !important;
  color: white;
  padding: 0.8rem !important;
}
.auth-btns li {
  /* padding: .5rem; */
}
.nav-searchBar {
  background: white;
  display: flex;
  align-items: center;
  padding: 5px;
}
.nav-searchBar input {
  outline: none;
  border: none;
  height: 1.5rem;
}
.profile-dropdown li {
  width: 100%;
  /* text-align: right; */
  padding: 1rem 0;
  list-style: none;
  line-height: 1rem;
  font-size: 1rem;
  font-weight: 600;
}
.profile-dropdown {
  padding-left: 10px;
  position: absolute;
  right: 40px;
  width: 20rem;
  /* width: 30%; */
  /* max-width: 30%; */
  background: lightseagreen;
  top: 90px;
  border-radius: 5px;
  color: #fff;
  z-index: 10;
}
.logout-button {
  cursor: default;
}
.logout-button:hover {
  cursor: pointer;
}
.h-96 {
  height: 400px !important;
}
.chart-box {
  /* height: 200px; */
  /* border: 2px solid black; */
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}
.chart-box canvas {
  max-width: 100%;
  max-height: 300px; /* Adjust height as needed */
}
.chart-box h3 {
  font-weight: 600;
}
.pie-chart-btn-list button:focus {
  outline: none !important;
  border: none !important;
}

.editor-name-in-nav {
  font-weight: 700;
  font-size: 16px;
  color: #1b0167;
}
`, "",{"version":3,"sources":["webpack://./src/Component/dasboard.css"],"names":[],"mappings":"AAAA;;CAEC;AAGD;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,WAAW;AACb;AACA;EACE,iDAAiD;EACjD,WAAW;AACb;AACA;;;EAGE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,oDAAoD;EACpD,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,sCAAsC;AACrD;;AAEA;EACE;;;;GAIC,EAAE,+CAA+C;EAClD,kBAAkB,EAAE,iEAAiE;AACvF;;AAEA;EACE,yBAAyB,EAAE,wDAAwD;AACrF;;AAEA;EACE,qFAAqF;EACrF,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oDAAoD;;EAEpD,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,2DAA2D;EAC3D;gDAC8C;EAC9C,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;;GAGG;AACH;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;;GAGG;AACH;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX;GACC;EACD,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB;IACE;EACF,oDAAoD;AACtD;;AAEA;;EAEE,oCAAoC;EACpC;;;;cAIY;;EAEZ,sBAAsB;AACxB;;AAEA;;uDAEuD;AACvD;;;GAGG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;;uDAEuD;;AAEvD;EACE;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,2BAAsB;IAAtB,sBAAsB;EACxB;AACF;AACA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB;uCACqC;AACvC;AACA;EACE,eAAe;EACf,iBAAiB,EAAE,4BAA4B;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/*\n    DEMO STYLE\n*/\n\n@import \"https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700\";\nbody {\n  font-family: \"Poppins\", sans-serif;\n  background: #fafafa;\n}\n\np {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.7em;\n  color: #393838;\n}\np strong {\n  font-weight: 900;\n}\n.btn {\n  background: linear-gradient(45deg, #1b0167, #000);\n  color: #fff;\n}\nul li a .btn {\n  background: linear-gradient(45deg, #1b0167, #000);\n  color: #fff;\n}\na,\na:hover,\na:focus {\n  color: inherit;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n\n.navbar {\n  padding: 15px 10px;\n  background: #fff;\n  border: none;\n  border-radius: 0;\n  margin-bottom: 40px;\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-btn {\n  box-shadow: none;\n  outline: none !important;\n  border: none;\n}\n\n.line {\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px dashed #ddd;\n  margin: 40px 0;\n}\n\n/* ---------------------------------------------------\n    SIDEBAR STYLE\n----------------------------------------------------- */\n\n.wrapper {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n}\n\n#sidebar {\n  position: sticky;\n  top: 0;\n  min-width: 275px !important;\n  max-width: 275px !important;\n  /* background: #7386d5; */\n  background: linear-gradient(45deg, #0d0d42e0, black);\n  color: #fff;\n  transition: all 0.3s;\n  height: 100vh;\n  /* overflow-x: scroll; */\n  overflow-y: scroll;\n}\n#sidebar::-webkit-scrollbar {\n  width: 10px; /* Adjust the width of the scrollbar */\n}\n\n#sidebar::-webkit-scrollbar-thumb {\n  background-color: rgb(\n    168,\n    168,\n    168\n  ); /* Customize the color of the scrollbar thumb */\n  border-radius: 6px; /* Adjust the border-radius to make the scrollbar thumb rounder */\n}\n\n#sidebar::-webkit-scrollbar-thumb:hover {\n  background-color: #444444; /* Customize the color of the scrollbar thumb on hover */\n}\n\n#sidebar::-webkit-scrollbar-track {\n  /* background-color: #7386d5 !important; Customize the color of the scrollbar track */\n  background: linear-gradient(45deg, #0d0d42e0, black) !important;\n}\n\n#sidebar.active {\n  margin-left: -275px !important;\n}\n\n#sidebar .sidebar-header {\n  /* padding: 25px; */\n  /* background: #6d7fcc; */\n  background: linear-gradient(45deg, #0d0d42e0, black);\n\n  font-weight: bolder;\n}\n.sidebar-header h3 {\n  background: none;\n  font-family: cursive;\n  font-weight: bolder !important;\n  /* color: #7aff79; */\n  /* box-shadow: rgba(-9.7, 8.1, -1.2, 0.35) -7px 17px 4px; */\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,\n    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;\n  padding: 25px;\n  font-size: 1.8rem;\n}\n#sidebar ul.components {\n  /* padding: 20px 0; */\n  border-bottom: 1px solid #47748b;\n}\n\n/* #sidebar ul .dashboard {\n    color: #fff;\n    padding: 10px;\n} */\n.dashboard {\n  padding: 1rem 0 !important;\n  font-weight: bold;\n}\n/* .dashboard:hover {\n  color: #7386D5;\n  background: #fff;\n} */\n#sidebar ul li a {\n  padding: 1rem 10px;\n  font-size: 17px;\n  display: block;\n  font-weight: 500;\n}\n#sidebar ul li .dropdown-toggle::after {\n  right: 0px;\n}\n\n#sidebar ul li a:hover {\n  /* color: #7386d5; */\n  /* color: linear-gradient(45deg, #0d0d42e0, black); */\n  background: linear-gradient(45deg, #0a0ab4e0, rgb(14, 14, 14));\n  /* background: #fff; */\n}\n\n#sidebar ul li.active > a,\na[aria-expanded=\"true\"] {\n  color: #fff;\n  /* background: #6d7fcc;\n  */\n  background: linear-gradient(45deg, #212197e0, rgba(0, 0, 0, 0.632));\n}\n\na[data-toggle=\"collapse\"] {\n  position: relative;\n}\n\n.dropdown-toggle::after {\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n}\n\nul ul a {\n  font-size: 0.9em !important;\n  padding-left: 30px !important;\n  /* background: #6d7fcc; */\n  background: linear-gradient(45deg, #0d0d42e0, black);\n}\n\nul.CTAs {\n  padding: 20px;\n}\n\nul.CTAs a {\n  text-align: center;\n  font-size: 0.9em !important;\n  display: block;\n  border-radius: 5px;\n  margin-bottom: 5px;\n}\n\na.download {\n  background: #fff;\n  /* color: #7386d5;\n   */\n  background: linear-gradient(45deg, #0d0d42e0, black);\n}\n\na.article,\na.article:hover {\n  /* background: #6d7fcc !important; */\n  background: linear-gradient(\n    45deg,\n    #0f0f52e0,\n    rgba(0, 0, 0, 0.873)\n  ) !important;\n\n  color: #fff !important;\n}\n\n/* ---------------------------------------------------\n    CONTENT STYLE\n----------------------------------------------------- */\n/* .authorCount-container {\n  display: flex;\n  gap: 10px;\n} */\n\n#content {\n  width: 100%;\n  padding: 20px;\n  min-height: 100vh;\n  transition: all 0.3s;\n}\n.chart-box {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.chart-box:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.chart-title {\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n}\n/* ---------------------------------------------------\n    MEDIAQUERIES\n----------------------------------------------------- */\n\n@media (max-width: 768px) {\n  #sidebar {\n    margin-left: -275px;\n  }\n  #sidebar.active {\n    margin-left: 0 !important;\n  }\n  #sidebarCollapse span {\n    display: none;\n  }\n}\n@media (max-width: 400px) {\n  .form-group select {\n    width: 225px !important;\n  }\n}\n\n@media (max-width: 450px) {\n  .form-group input {\n    max-width: fit-content;\n  }\n}\n/* dashboard.css */\n#content {\n  width: 100%;\n  padding: 15px;\n  transition: all 0.3s;\n  background: #040420;\n}\n\n/* Toggle Button */\n#sidebarCollapse {\n  background-color: transparent;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n/* Navbar Styles */\n.navbar {\n  background-color: #fff;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s;\n}\n\n.navbar .navbar-toggler {\n  background-color: #37474f;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n/* Miscellaneous */\n.line {\n  height: 1px;\n  background-color: #ccc;\n  margin: 20px 0;\n}\n\n.list-unstyled {\n  padding: 0;\n  list-style: none;\n}\n\n.list-unstyled a {\n  color: white;\n  text-decoration: none;\n}\n\n.list-unstyled a:hover {\n  color: #fff;\n}\n\n/* Active link */\n.list-unstyled .active > a {\n  background-color: #263238;\n  color: #fff;\n}\n\n/* Dropdown Styles */\n.collapse.show {\n  display: block;\n}\n\n.list-unstyled .dropdown-toggle::after {\n  float: right;\n  margin-left: auto;\n  margin-right: 15px;\n}\n\n/* CTAs Styles */\n.CTAs {\n  padding: 20px;\n}\n\n.CTAs a {\n  color: #007bff;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n\n.CTAs a:hover {\n  color: #0056b3;\n  text-decoration: none;\n}\n\n/* Additional Styling for Overlay */\n#overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 1;\n}\n.auth-btns button {\n  background: white;\n  font-weight: 600;\n}\n.auth-btns li a {\n  /* padding: 0; */\n  /* background: rgb(46, 46, 248); */\n  font-weight: bold !important;\n  color: white;\n  padding: 0.8rem !important;\n}\n.auth-btns li {\n  /* padding: .5rem; */\n}\n.nav-searchBar {\n  background: white;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n.nav-searchBar input {\n  outline: none;\n  border: none;\n  height: 1.5rem;\n}\n.profile-dropdown li {\n  width: 100%;\n  /* text-align: right; */\n  padding: 1rem 0;\n  list-style: none;\n  line-height: 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n}\n.profile-dropdown {\n  padding-left: 10px;\n  position: absolute;\n  right: 40px;\n  width: 20rem;\n  /* width: 30%; */\n  /* max-width: 30%; */\n  background: lightseagreen;\n  top: 90px;\n  border-radius: 5px;\n  color: #fff;\n  z-index: 10;\n}\n.logout-button {\n  cursor: default;\n}\n.logout-button:hover {\n  cursor: pointer;\n}\n.h-96 {\n  height: 400px !important;\n}\n.chart-box {\n  /* height: 200px; */\n  /* border: 2px solid black; */\n  border-radius: 16px;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,\n    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;\n}\n.chart-box canvas {\n  max-width: 100%;\n  max-height: 300px; /* Adjust height as needed */\n}\n.chart-box h3 {\n  font-weight: 600;\n}\n.pie-chart-btn-list button:focus {\n  outline: none !important;\n  border: none !important;\n}\n\n.editor-name-in-nav {\n  font-weight: 700;\n  font-size: 16px;\n  color: #1b0167;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
